module.exports = __webpack_public_path__ + "img/logo@2x.225e4238.png";